import { render, staticRenderFns } from "./AppAccount.vue?vue&type=template&id=4b7f0425&"
import script from "./AppAccount.vue?vue&type=script&lang=js&"
export * from "./AppAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\2000HuiTian\\huitianadmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b7f0425')) {
      api.createRecord('4b7f0425', component.options)
    } else {
      api.reload('4b7f0425', component.options)
    }
    module.hot.accept("./AppAccount.vue?vue&type=template&id=4b7f0425&", function () {
      api.rerender('4b7f0425', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/AppAccount.vue"
export default component.exports